import React, { useEffect, useMemo, useState } from 'react';

import Grid from "@mui/material/Grid";

import { addDays, addMonths, subDays } from 'date-fns';

import Calendar from 'react-calendar';
import moment from "moment-timezone";

import { TCTitleLabel, TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import EventIcon from '@mui/icons-material/Event';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

import 'react-calendar/dist/Calendar.css';
import { getCourtsSchedule, getCourts, getPlaceDetail, getServerTime } from 'services/placeServices';
import { fontSize, minWidth } from '@mui/system';
import { getPlayerCourtSchedule, getPlayerSchedule } from 'services/playerServices';
import { isMobile } from 'react-device-detect';
import { EventAvailable } from '@mui/icons-material';
import addOnSVG from "../../assets/addon.svg"
import { Dialog } from '@mui/material';
import SlideAlert from 'components/SlideInAlert/SlideAlert';
import { Confirm, ConfirmActionBody } from 'helper/Alert';
import { getCourtTypes } from "services/courtTypeServices"
import { isMerchant } from 'helper/Admin';
import { TCSelect } from './Input/TopCourtInput';
import { getCourtPlace } from 'helper/LocalStorage';

function TCCalendar({
    data,
    onChangeForm,
    userId,
    viewOnly,
}) {

    const [placeId, setPlaceId] = useState("653f5d9006520fccd4ab4604")
    const [selectedDefaultDate, setSelectedDefaultDate] = useState(new Date())

    const [courts, setCourts] = useState([])
    const [availableHours, setAvailableHours] = useState(Hours)

    const [hourList, setHourList] = useState([])
    const [openCalendar, setOpenCalendar] = useState(false)

    const [serverDate, setServerDate] = useState(new Date())

    const [form, setForm] = useState({
        selectedDate: toLocalGMT(new Date()),
        date: toGMT7(new Date()),
        month: toGMT7(new Date(), 'MM'),
        year: toGMT7(new Date(), 'YYYY'),
        court: null,
        hours: [],
        totalSessions: 0,
        totalPrice: 0,
    })

    const [user, setUser] = useState(null)
    const [playerSchedule, setPlayerSchedule] = useState([])
    const [booking, setBooking] = useState([])
    const [allowLoad, setAllowLoad] = useState(false)
    const [courtTypeOption, setCourtTypeOption] = useState([])

    let place = JSON.parse(localStorage.getItem("court_place"))

    const placeOptions = useMemo(
        () =>
            place.map(v => ({
                value: v.id,
                label: v.name,
            })),
        [place]
    );

    const [selectedPlace, setSelectedPlace] = useState(placeOptions[0])

    const loadCourtType = async () => {
        let { data, error } = await getCourtTypes({ placeId, isActive: true })
        if (error) { console.log(error) }
        if (data) {
            let courtTypeData = []
            for (let i = 0; i < data.length; i++) {
                courtTypeData.push({
                    label: data[i].courtTypeId ? data[i].courtTypeId.name : data[i].name,
                    value: data[i].courtType
                })
            }
            setCourtTypeOption(courtTypeData)
        }
    }
    useEffect(() => {
        getServerDate()
    }, [])

    useEffect(() => {
        loadCourtType()
        getPlayerScheduleList()
        loadCourts()
    }, [placeId])

    useEffect(() => {
        getPlayerScheduleList()
    }, [form.month, form.year])

    useEffect(() => {
        if (selectedPlace.value && !isMerchant()) {
            setPlaceId(selectedPlace.value)
        } else {
            setPlaceId(getCourtPlace().id)
        }
    }, [selectedPlace])

    const getPlayerScheduleList = async () => {
        if (userId && userId != 'undefined') {
            let { data, error } = await getPlayerSchedule({
                userId,
                month: form.month,
                year: form.year,
                placeId
            })
            if (error) { console.log(error) }
            if (data) {
                setHourList(data.data)
            }
        }
    }

    const checkBookingHours = (date, court) => {
        let dateString = toGMT7(date, 'YYYY-MM-DD')
        court = form.court
        let bookingInfo = {
            hours: [],
            totalSessions: 0,
            totalPrice: 0
        }
        for (let i = 0; i < booking.length; i++) {
            let courtId = (booking[i].court && booking[i].court._id) ? booking[i].court._id.toString() : booking[i].court.toString()
            if (booking[i].date == dateString && courtId == court.toString()) {
                // hours = booking[i].hours;
                bookingInfo.hours = booking[i].hours
                bookingInfo.totalSessions = booking[i].totalSessions
                bookingInfo.totalPrice = booking[i].totalPrice
                break;
            }
        }
        return bookingInfo
    }

    useEffect(() => {
        if (userId && userId != 'undefined' && form.court) {
            getPlayerBookingDateList()
            if (allowLoad) { loadCourts() }
        }
    }, [form.date])

    useEffect(() => {
        if (form.court) {
            if (userId && userId != 'undefined') {
                getPlayerBookingDateList()
            } else { getBookingsDateList() }
        }
    }, [form.date, form.court])

    useEffect(() => {
        console.log('here info server Date', serverDate)
        setForm(prev => ({
            ...prev,
            selectedDate: serverDateConstructor(new Date(serverDate)),
            date: toGMTSelectedDate(serverDateConstructor(serverDate)),
            month: toGMTSelectedDate(serverDateConstructor(serverDate), 'MM'),
            year: toGMTSelectedDate(serverDateConstructor(serverDate), 'YYYY'),
        }))
        setSelectedDefaultDate(serverDateConstructor(serverDate))
    }, [serverDate])

    useEffect(() => {
        onChangeForm(form)
    }, [form])

    useEffect(() => {
        let bookingHours = checkBookingHours(new Date(form.date))
        onChange({
            ...bookingHours
        });
    }, [booking])

    const onChange = (e) => {
        setForm(prev => ({
            ...prev,
            ...e
        }))
    }

    const getServerDate = async () => {
        let { data, error } = await getServerTime()
        if (data) { setServerDate(data) }
    }

    const loadCourts = async () => {
        try {
            let { data, error } = await getCourts(placeId, form.date, userId)
            setCourts(data.courts)
            let isChangeVenue = data.courts.some(v => v._id == form.court)
            setForm(prev => ({
                ...prev,
                court: prev.court && isChangeVenue ? prev.court : data.courts[0]._id,
                courtData: prev.courtData && isChangeVenue ? prev.courtData : data.courts[0],
            }))
            setAllowLoad(true)
        } catch (error) {
            console.log(error)
        }
    }

    const getPlayerBookingDateList = async () => {
        try {
            let { data, error } = await getPlayerCourtSchedule({
                userId,
                court: form.court,
                date: form.date
            })
            if (error) { throw error }
            let courtSchedule = data.data
            if (data) setAvailableHours(courtSchedule.hours)
        } catch (error) {
            console.log(error)
        }
    }

    const getBookingsDateList = async () => {
        try {
            let { data, error } = await getCourtsSchedule(form.court, form.date)
            if (error) { throw error }
            if (data) setAvailableHours(data.hours)
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            {
                !isMerchant() &&
                <TCSelect inDialog={true} label={"Venue"} options={placeOptions || []} value={selectedPlace} styles={{
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                    // overall height
                    control: (base) => ({
                        ...base,
                        marginBottom: 10,
                        minWidth: 200
                        // fontSize: '13px',
                        // border: '0.5px',
                        // backgroundColor: '#f8fafc',
                        // borderRadius: 2,
                        // minHeight: 28
                    }),

                    // make the indicator area smaller (both chevron + clear X)
                    dropdownIndicator: (base) => ({ ...base, padding: 2 }),   // was ~8
                    clearIndicator: (base) => ({ ...base, padding: 2 }),
                    indicatorsContainer: (base) => ({ ...base, paddingRight: 0 }),

                    // thinner/shorter separator (or hide with display:'none')
                    indicatorSeparator: (base) => ({
                        ...base,
                        width: 1,
                        marginTop: 6,
                        marginBottom: 6,
                        opacity: 0.6,
                    }),
                }}
                    onChange={(e) => {
                        setPlaceId(e.value)
                        onChange({ court: e.value })
                        setSelectedPlace(e)
                    }}
                />
            }
            {
                !openCalendar &&
                <>
                    <div style={{ width: '100%' }}>
                        <Grid item container justifyContent={"flex-start"} >
                            <Grid item xs={2.75} textAlign={"center"}>
                                <div className={form.month === momentFormat(selectedDefaultDate, 'MM') ? 'calendar-custom-header-selected' : 'calendar-custom-header'}
                                    onClick={() => {
                                        onChange({
                                            month: momentFormat(selectedDefaultDate, 'MM'),
                                            year: momentFormat(selectedDefaultDate, 'YYYY')
                                        })
                                    }}
                                >
                                    {momentFormat(selectedDefaultDate, 'MMM YY')}
                                </div>
                            </Grid>
                            <Grid item xs={2.75} textAlign={"center"}>
                                <div className={form.month === momentFormat(addMonths(selectedDefaultDate, 1), 'MM') ? 'calendar-custom-header-selected' : 'calendar-custom-header'}
                                    onClick={() => {
                                        onChange({
                                            month: momentFormat(addMonths(selectedDefaultDate, 1), 'MM'),
                                            year: momentFormat(addMonths(selectedDefaultDate, 1), 'YYYY')
                                        })
                                    }}
                                >
                                    {momentFormat(addMonths(selectedDefaultDate, 1), 'MMM YY')}
                                </div>
                            </Grid>
                            <Grid item xs={2.75} textAlign={"center"}>
                                <div className={form.month === momentFormat(addMonths(selectedDefaultDate, 2), 'MM') ? 'calendar-custom-header-selected' : 'calendar-custom-header'}
                                    onClick={() => {
                                        onChange({
                                            month: momentFormat(addMonths(selectedDefaultDate, 2), 'MM'),
                                            year: momentFormat(addMonths(selectedDefaultDate, 2), 'YYYY')
                                        })
                                    }}
                                >
                                    {momentFormat(addMonths(selectedDefaultDate, 2), 'MMM YY')}
                                </div>
                            </Grid>
                            <Grid item xs={2.75} textAlign={"center"}>
                                <div className={form.month === momentFormat(addMonths(selectedDefaultDate, 3), 'MM') ? 'calendar-custom-header-selected' : 'calendar-custom-header'}
                                    onClick={() => {
                                        onChange({
                                            month: momentFormat(addMonths(selectedDefaultDate, 3), 'MM'),
                                            year: momentFormat(addMonths(selectedDefaultDate, 3), 'YYYY')
                                        })
                                    }}
                                >
                                    {momentFormat(addMonths(selectedDefaultDate, 3), 'MMM YY')}
                                </div>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"} justifyContent={"center"}>
                                <div
                                    className='calendar-custom-header'
                                    style={{ fontSize: 15, padding: 0 }}
                                    onClick={() => {
                                        setOpenCalendar(true)
                                    }}
                                >
                                    <div style={{ marginTop: 5 }}>
                                        <EventIcon sx={{ fontSize: 19.5 }} />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        {/* <Calendar 
                            className={"react-calendar"}
                            onChange={(e) => {
                                let bookingInfo = checkBookingHours(e)
                                onChange({
                                    selectedDate: toLocalGMT(e),
                                    date: toGMT7(e), 
                                    ...bookingInfo,
                                });
                            }}
                            tileClassName={(({date}) => {
                                // let dateConstructor = `${date.getFullYear()}-${date.getMonth() > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`}-${date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`}`
                                // // console.log('hour list, from calendar', date, moment(date).format('YYYY-MM-DD'), moment(form.selectedDate).format('YYYY-MM-DD'), dateConstructor)
                                // if (moment(date).format('YYYY-MM-DD') == moment(form.selectedDate).format('YYYY-MM-DD')) {
                                //     return;
                                // }
                                // if (hourList.indexOf(dateConstructor) >= 0) {
                                //     return 'dotted'
                                // }
                                if (moment(date).format('YYYY-MM-DD') == moment(form.selectedDate).format('YYYY-MM-DD')) {
                                    return;
                                }
                                if (hourList.indexOf(moment(date).format('YYYY-MM-DD')) >= 0) {
                                    return 'dotted'
                                }
                            })}
                            minDate={data ? null : new Date()}
                            // maxDate={new Date(moment(addDays(new Date(), user ? (user.package && user.package.advancedDays) ? user.package.advancedDays : 31 : 31)).endOf('month'))} // Count by Days
                            // maxDate={new Date(moment(addMonths(new Date(), user ? (user.activeBenefits && user.activeBenefits.advancedMonths) ? user.activeBenefits.advancedMonths : 0 : 0)).endOf('month'))} // Count by Months
                            defaultValue={form.selectedDate} 
                            value={form.selectedDate}
                            showNavigation={false}
                            // activeStartDate={new Date(`${form.month}-01-${form.year}`)}
                            activeStartDate={new Date(form.year, (form.month - 1), 1)}
                        /> */}
                        <Calendar
                            className="react-calendar"
                            onChange={(e) => {
                                const jakartaDate = moment.tz(
                                    {
                                        year: e.getFullYear(),
                                        month: e.getMonth(),
                                        day: e.getDate(),
                                    },
                                    'Asia/Jakarta'
                                ).format('YYYY-MM-DD');

                                const bookingInfo = checkBookingHours(e);
                                console.log('onChange-date x-Date', jakartaDate)
                                console.log('onChange-selected x-Date:', toLocalGMT(e));

                                onChange({
                                    selectedDate: toLocalGMT(e),
                                    date: jakartaDate,
                                    ...bookingInfo,
                                });
                            }}
                            // tileClassName={({ date }) => {
                            //     let dateInfo = moment(date).utcOffset(0).toISOString('YYYY-MM-DD HH:mm:ss')
                            //     const calendarDate = moment.tz(
                            //         {
                            //             year: date.getFullYear(),
                            //             month: date.getMonth(),
                            //             day: date.getDate(),
                            //         },
                            //         'Asia/Jakarta'
                            //     ).format('YYYY-MM-DD');

                            //     const selectedDate = moment.tz(form.selectedDate, 'Asia/Jakarta')
                            //     .format('YYYY-MM-DD');

                            //     if (calendarDate === selectedDate) {
                            //         console.log('here dateInfo x-Date', dateInfo, new Date(dateInfo))
                            //         console.log('Calendar x-Date:', date);
                            //         console.log('Calendar x-Date:', calendarDate);
                            //         console.log('Selected x-Date:', selectedDate);
                            //         console.log('HourList:', hourList);
                            //         return;
                            //     }

                            //     if (hourList.includes(calendarDate)) {
                            //         return 'dotted';
                            //     }

                            //     return null;
                            // }}
                            tileClassName={(({ date }) => {
                                const calendarDate = toGMTSelectedDate(date);
                                const selectedDate = toGMTSelectedDate(form.selectedDate);

                                // console.log('Calendar Date:', calendarDate);
                                // console.log('Selected Date:', selectedDate);
                                // console.log('Server Date:', serverMomentDate);
                                // console.log('Selected Date - check:', toGMTSelectedDate(serverDate), serverDate);
                                // console.log('HourList:', hourList);
                                if (calendarDate == selectedDate) {
                                    return;
                                }
                                if (hourList.indexOf(calendarDate) >= 0) {
                                    return 'dotted'
                                }
                            })}
                            minDate={data ? null : toLocalGMT(new Date())}
                            defaultValue={form.selectedDate}
                            value={form.selectedDate}
                            showNavigation={false}
                            activeStartDate={new Date(form.year, form.month - 1, 1)}
                        />
                    </div>
                    <div style={{ border: '0.5px solid #3447671F', height: '0.5px', marginTop: 10, width: '100%' }} />
                    <Grid container item xs={12} md={12} lg={12}>
                        <CourtComponent courtInfo={[]} form={form} courtTypeOption={courtTypeOption} courts={courts} onChange={onChange} checkBookingHours={checkBookingHours} />
                        <HoursComponent availableHours={availableHours} onChange={onChange} form={form} isNotActiveCalendar={selectedDefaultDate}
                            viewOnly={viewOnly} user={userId}
                        />
                    </Grid>
                </>
            }
            {
                openCalendar &&
                <MonthSelection selectedDate={form.selectedDate}
                    onChangeCalendar={(e) => {
                        setSelectedDefaultDate(e)
                        // setSwipeState(0)
                        setForm(prev => ({
                            ...prev,
                            selectedDate: toLocalGMT(e),
                            date: toGMT7(e),
                            month: toGMT7(e, 'MM'),
                            year: toGMT7(e, 'YYYY'),
                            hours: [],
                            totalSessions: 0,
                            totalPrice: 0,
                        }))
                    }}
                    closeCalendar={(e) => {
                        setOpenCalendar(e)
                    }}
                />
            }
        </>
    )
}

function CourtComponent({
    courtInfo,
    form,
    courtTypeOption,
    courts,
    onChange,
    checkBookingHours
}) {
    const order = [...new Set(courts.map(c => c.courtType))];
    return (
        <Grid container>
            <Grid item mt={1} mb={1} xs={12} md={12} lg={12}>
                <div style={{ display: 'flex', width: '100%', justifyContent: 'left' }}>
                    <div style={{ marginLeft: 0, display: 'flex', justifyContent: 'left' }}>
                        <TCLabel bold>Court</TCLabel>
                    </div>
                </div>
            </Grid>
            <div style={{
                display: 'flex',
                overflowY: 'auto',
                whiteSpace: 'nowrap',
                width: '100%'
            }}>
                <div className="scrollableContainer">
                    {
                        courtTypeOption.map((type, index) => {
                            let hasCourt = courts.filter((court) => court.courtType === type.value).length > 0
                            if (hasCourt) {
                                return (
                                    <div key={type.value} className="court-type-group">
                                        <div className="court-type-label">
                                            <Grid xs={12} item textAlign={"center"}>
                                                <TCLabel>{type.label}</TCLabel>
                                            </Grid>
                                            <div className="courts-list">
                                                {/* {courts.filter((court) => court.courtType === type.value).length > 0 ?  */}

                                                {
                                                    courts.filter((court) => court.courtType === type.value)
                                                        .map((court) => (
                                                            <Grid item container style={{ paddingTop: 3 }} justifyContent={"center"}>
                                                                <div className='court-container'>
                                                                    <div className={form.court === court._id ? 'selection-selected' : 'selection-available'}
                                                                        style={{
                                                                            position: 'relative',
                                                                            textAlign: 'center',
                                                                            padding: 2,
                                                                            paddingLeft: 8,
                                                                            paddingRight: 8,
                                                                            minWidth: 30,
                                                                            marginRight: 2,
                                                                            borderRadius: '6px 6px 6px 6px',
                                                                            overflow: 'hidden',
                                                                        }}
                                                                        onClick={() => {
                                                                            let courtInfo = checkBookingHours(new Date(form.date), court._id)
                                                                            onChange({
                                                                                court: court._id,
                                                                                courtData: court,
                                                                                ...courtInfo
                                                                            })
                                                                        }}>
                                                                        {court.isBooked && (<div className='ribbon'></div>)} {court.name}
                                                                    </div>
                                                                </div>
                                                            </Grid>))
                                                }

                                                {/* :
                                                <div style={{ fontStyle: 'italic', color: '#999', fontSize: '14px' }}>Loading</div> } */}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })
                    }
                </div>
            </div>
        </Grid>
    )
}

function HoursComponent({
    form,
    onChange,
    availableHours,
    viewOnly,
    user,
    isNotActiveCalendar
}) {

    const [calendarBody, setCalendarBody] = useState({
        open: false,
        info: null,
        actionBody: null
    })

    useEffect(() => {
    }, [calendarBody])

    const updateSelectedTime = (value) => {

        let index = form.hours.indexOf(value.label);
        let newForm = form.hours;
        let sessions = form.totalSessions;
        let total = form.totalPrice;

        if (value.active && index < 0) {

            newForm = [...form.hours, value.label];
            sessions += 1;
            total += value.nominee;

        } else if (index >= 0) {

            newForm.splice(index, 1);
            sessions -= 1;
            total -= value.nominee;

        }

        onChange({ hours: newForm, totalSessions: sessions, totalPrice: total })
    }

    const getEventName = (e) => {
        let name = e.classBooked ? "Class Schedule" : "Event"
        if (e.tournamentBooked === true && e.tournamentObject.length > 0) {
            for (let i = 0; i < e.tournamentObject.length; i++) {
                if (e.tournamentObject[i].hours.indexOf(e.label) >= 0) {
                    if (e.tournamentObject[i].classLink) {
                        return <div onClick={() => {
                            window.location.href = `/class/detail/${e.tournamentObject[i].classLink}`
                        }}>
                            <TCLabel bold>{e.tournamentObject[i].eventName}</TCLabel>
                        </div>
                    } else {
                        return e.tournamentObject[i].eventName
                    }
                }
            }
        }
        if (e.classBooked === true && e.classObject.length > 0) {
            for (let i = 0; i < e.classObject.length; i++) {
                if (e.classObject[i].hours.indexOf(e.label) >= 0) {
                    if (e.classObject[i].href) {
                        return <div onClick={() => {
                            window.location.href = `/class/detail/${e.classObject[i].href}`
                            // window.location.href = e.classObject[i].href
                        }}>
                            <TCLabel bold>{e.classObject[i].name}</TCLabel>
                        </div>
                    } else {
                        return e.classObject[i].name
                    }
                }
            }
        }
        return name
    }

    const checkHoursItems = (e) => {
        if (e.listItem && e.listItem.length > 0) {
            for (let i = 0; i < e.listItem.length; i++) {
                let hoursInfo = e.listItem[i].hours
                if (hoursInfo.indexOf(e.label) >= 0) { return true; }
            }
        }
        return false
    }

    const checkListItem = (title, e) => {
        let itemList = e.listItem || []
        let listCoach = []
        let listRP = []
        let listBB = []
        let listRent = []
        let listCoachObj = []
        let showList = true
        let isCoachClass = false
        if (e.classBooked) {
            showList = false
            if (e.coachedClass) {
                if (e.classObject) {
                    for (let i = 0; i < e.classObject.length; i++) {
                        if (e.classObject[i].hours.indexOf(e.label) >= 0) { isCoachClass = true }
                    }
                }
                showList = true
            }
        }
        if (!showList) {
            return {
                info: <Grid container sx={{
                    minHeight: 80,
                    maxHeight: 120,
                    padding: 0,
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Grid item xs={12}>
                        <TCLabel bold>{title}</TCLabel>
                    </Grid>
                </Grid>,
                actionBody: null
            }
        }
        for (let i = 0; i < itemList.length; i++) {
            if (itemList[i].hours.indexOf(e.label) >= 0) {
                if (itemList[i].productInfo.category == "Coach" ||
                    itemList[i].productInfo.category == "Development Coach" ||
                    itemList[i].productInfo.category == "Lead Coach" ||
                    itemList[i].productInfo.category == "Senior Coach" ||
                    itemList[i].productInfo.category == "Head Coach"
                ) {
                    listCoach.push(itemList[i].productInfo.name)
                    listCoachObj.push({
                        _id: itemList[i].item,
                        name: itemList[i].productInfo.name
                    })
                }
                if (itemList[i].productInfo.category == "Rally Partner") {
                    listRP.push(itemList[i].productInfo.name)
                    // listRP.push({
                    //     image: itemList[i].productInfo.image,
                    //     name: itemList[i].productInfo.name
                    // })
                }
                if (itemList[i].productInfo.category == "Ball Boy") {
                    listBB.push(itemList[i].productInfo.name)
                    // listBB.push({
                    //     image: itemList[i].productInfo.image,
                    //     name: itemList[i].productInfo.name
                    // })
                }
                if (itemList[i].order && itemList[i].order.orderType == "rent") {
                    listRent.push(itemList[i].productInfo.name)
                    // listRent.push({
                    //     image: itemList[i].productInfo.image,
                    //     name: itemList[i].productInfo.name
                    // })
                }
            }
        }
        if ((e.coachedClass && e.coachedClass.length > 0) && isCoachClass) {
            // tampilkan seperti di CMS dan counter
            listCoach = listCoachObj
            let selectedCoachParticipant = []
            for (let j = 0; j < listCoach.length; j++) {
                let coachList = []
                for (let k = 0; k < e.classParticipant.length; k++) {
                    let participants = e.classParticipant[k]
                    if (participants.service && participants.service.length >= listCoach.length) { continue; }
                    if (participants.service && participants.service.indexOf(listCoach[j]._id) >= 0) {
                        coachList.push(participants)
                        selectedCoachParticipant.push(participants._id)
                    }
                }
                listCoach[j].coachingList = coachList
            }

            return {
                info: <Grid container sx={{
                    minHeight: 80,
                    maxHeight: 120,
                    padding: 0,
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Grid item xs={12}>
                        <TCLabel bold>{title}</TCLabel>
                    </Grid>
                    {/* {
                        listCoach && listCoach.length > 0 &&
                        <Grid item xs={12} mt={.5} textAlign={"left"}>
                            <TCLabel style={{fontSize: 10}} bold>Coach: {listCoach.toString()}</TCLabel>
                        </Grid>
                    } */}
                    {
                        (listCoach && listCoach.length > 0) && listCoach.map(v => {
                            return (
                                <Grid container spacing={0.5}>
                                    <Grid item>
                                        <TCLabel style={{ fontSize: 10 }} bold>{`Coach:`}</TCLabel>
                                    </Grid>
                                    <Grid item>
                                        <TCLabel style={{ fontSize: 10 }} bold>{`${v.name}`}</TCLabel>
                                    </Grid>
                                    <Grid item contain xs={12} mt={-0.5} textAlign={"left"}>
                                        {
                                            v.coachingList.map((val, index) => {
                                                if (val.hours) { if (val.hours.indexOf(e.label) < 0) { return; } }
                                                return (
                                                    <Grid item>
                                                        <TCLabel style={{ fontSize: 10 }}>{`${val.attend ? '✔' : ''} ${val.user.name.toString()} (${val.pax}) ${(index !== v.coachingList.length - 1 ? ',' : '')}`}</TCLabel>
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                    {
                        listRP && listRP.length > 0 &&
                        <Grid item xs={12} mt={.5} textAlign={"left"}>
                            <TCLabel style={{ fontSize: 10 }} bold>Rally Partner: {listRP.toString()}</TCLabel>
                            {/* {
                                listRP.map(v => {
                                    return (
                                        <Grid item xs={12}>
                                            {v.name}
                                        </Grid>
                                    )
                                })
                            } */}
                        </Grid>
                    }
                    {
                        listBB && listBB.length > 0 &&
                        <Grid item xs={12} mt={.5} textAlign={"left"}>
                            <TCLabel style={{ fontSize: 10 }} bold>Ball Boy: {listBB.toString()}</TCLabel>
                            {/* {
                                listBB.map(v => {
                                    return (
                                        <Grid item xs={12}>
                                            {v.name}
                                        </Grid>
                                    )
                                })
                            } */}
                        </Grid>
                    }
                    {
                        listRent && listRent.length > 0 &&
                        <Grid item xs={12} mt={.5} textAlign={"left"}>
                            <TCLabel style={{ fontSize: 10 }} bold>Rent: {listRent.toString()}</TCLabel>
                            {/* {
                                listRent.map(v => {
                                    return (
                                        <Grid item xs={12}>
                                            {v.name}
                                        </Grid>
                                    )
                                })
                            } */}
                        </Grid>
                    }
                    {
                        e.classParticipant && e.classParticipant.length > 0 &&
                        <Grid container spacing={0.5}>
                            {/* <Grid item>
                            <TCLabel style={{fontSize: 10, color: 'white'}} bold>{`Participant:`}</TCLabel>
                        </Grid> */}
                            <Grid item>
                                <div style={{
                                    overflowX: 'auto'
                                }}>
                                    {
                                        e.classParticipant.map((v, index) => {
                                            if (selectedCoachParticipant.indexOf(v._id) >= 0) { return; }
                                            if (v.hours) { if (v.hours.indexOf(e.label) < 0) { return; } }
                                            return (
                                                <Grid item>
                                                    <TCLabel style={{ fontSize: 10 }}>{`${v.attend ? '✔' : ''} ${v.user.name.toString()} (${v.pax}) ${(index !== e.classParticipant.length - 1 ? ',' : '')}`}</TCLabel>
                                                </Grid>
                                            )
                                        })
                                    }
                                </div>
                            </Grid>
                        </Grid>
                    }
                </Grid>,
                actionBody: null
            }
        }

        let availableService = listCoach.length > 0 || listRP.length > 0 || listBB.length > 0 || listRent.length > 0
        // let endHours = e.label.split(":")
        // if (endHours.length > 0) { 
        //     endHours = Number(endHours[0]) + 1
        // }
        return {
            info: <Grid container sx={{
                minHeight: 80,
                maxHeight: 120,
                padding: 0,
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Grid item xs={12}>
                    <TCLabel bold>{title}</TCLabel>
                    {/* <TCLabel style={{fontSize: 11}} bold>{`${moment(form.date).format('ddd DD/MM/yyyy')} ${e.label} - ${endHours > 9 ? `${endHours}:00` : `0${endHours}:00`}`}</TCLabel> */}
                </Grid>
                {
                    listCoach && listCoach.length > 0 &&
                    <Grid item xs={12} mt={.5} textAlign={"left"}>
                        <TCLabel style={{ fontSize: 10 }} bold>Coach: {listCoach.toString()}</TCLabel>
                        {/* {
                            listCoach.map(v => {
                                return (
                                    <Grid item xs={12}>
                                        <img src={v.image} width={60} height={'auto'} />
                                        {v.name}
                                    </Grid>
                                )
                            })
                        } */}
                        {/* <TCLabel>{listCoach.toString()}</TCLabel> */}
                    </Grid>
                }
                {
                    listRP && listRP.length > 0 &&
                    <Grid item xs={12} mt={.5} textAlign={"left"}>
                        <TCLabel style={{ fontSize: 10 }} bold>Rally Partner: {listRP.toString()}</TCLabel>
                        {/* {
                            listRP.map(v => {
                                return (
                                    <Grid item xs={12}>
                                        {v.name}
                                    </Grid>
                                )
                            })
                        } */}
                    </Grid>
                }
                {
                    listBB && listBB.length > 0 &&
                    <Grid item xs={12} mt={.5} textAlign={"left"}>
                        <TCLabel style={{ fontSize: 10 }} bold>Ball Boy: {listBB.toString()}</TCLabel>
                        {/* {
                            listBB.map(v => {
                                return (
                                    <Grid item xs={12}>
                                        {v.name}
                                    </Grid>
                                )
                            })
                        } */}
                    </Grid>
                }
                {
                    listRent && listRent.length > 0 &&
                    <Grid item xs={12} mt={.5} textAlign={"left"}>
                        <TCLabel style={{ fontSize: 10 }} bold>Rent: {listRent.toString()}</TCLabel>
                        {/* {
                            listRent.map(v => {
                                return (
                                    <Grid item xs={12}>
                                        {v.name}
                                    </Grid>
                                )
                            })
                        } */}
                    </Grid>
                }
            </Grid>,
            actionBody: null
        }
    }

    return (
        <Grid container>
            <Grid mb={1} item>
                <TCLabel bold>Time</TCLabel>
            </Grid>
            <Grid item container spacing={2}>
                {
                    availableHours.map(value => {
                        return (
                            <Grid item xs={isMobile ? 3 : 2}>
                                <div className={
                                    value.tournamentBooked ? 'selection-booked-others' :
                                        value.idle ? 'selection-idle' :
                                            value.ownBooked ? 'selection-booked-own' :
                                                value.booked ? value.ownBooked ? 'selection-booked-own' :
                                                    value.classBooked ? 'selection-booked-own' : 'selection-booked' :
                                                    value.active ?
                                                        form.hours.indexOf(value.label) >= 0 ?
                                                            'selection-selected' :
                                                            'selection-available'
                                                        : 'selection-disabled'
                                }
                                    style={{
                                        textAlign: 'center', padding: 5,
                                        minWidth: 25, minHeight: 50, borderRadius: 8
                                    }}
                                    onClick={() => {
                                        if (viewOnly && (value.idle || value.booked)) {
                                            let information = checkListItem(value.idle ? "Awaiting payment. Please check again" : value.ownBooked ? `User booking`
                                                : (value.classBooked && value.tournamentBooked) ? getEventName(value) : value.classBooked ? getEventName(value) : value.tournamentBooked ? getEventName(value) : "Court is booked", value)
                                            // setCalendarBody({
                                            //     info: information.info,
                                            //     actionBody: information.actionBody,
                                            //     open: true
                                            // })
                                            ConfirmActionBody("", information.info, information.actionBody)
                                            return;
                                        }
                                        // if (isNotActiveCalendar) { return; }
                                        if (!value.active) { return; }
                                        if (!viewOnly && (!value.idle && !value.booked)) { updateSelectedTime(value) }
                                    }}
                                >
                                    {/* <MKTypography variant="small" fontWeight="regular" color="inherit">{value.label}</MKTypography> */}
                                    <div>{value.label}</div>
                                    {
                                        value.idle ? <AccessTimeIcon sx={{ fontSize: 10 }} /> :
                                            value.tournamentBooked ? <EventAvailableIcon sx={{ fontSize: 10 }} /> :
                                                value.ownBooked && value.classBooked ? <span>
                                                    <EventAvailableIcon sx={{ fontSize: 10 }} />
                                                    <SportsTennisIcon sx={{ fontSize: 10 }} />
                                                </span> :
                                                    (value.ownBooked && checkHoursItems(value)) ? <div><EventAvailableIcon sx={{ fontSize: 10 }} /><img src={addOnSVG} alt='' style={{ width: '0.9em', height: '1em' }} /></div> :
                                                        (value.classBooked && checkHoursItems(value)) ? <div><SportsTennisIcon sx={{ fontSize: 10 }} /><img src={addOnSVG} alt='' style={{ width: '0.9em', height: '1em' }} /></div> :
                                                            // (value.ownBooked && (value.listItem && value.listItem.length > 0)) ? <div><Icon>event_available</Icon><Icon>loupe</Icon></div> : 
                                                            value.ownBooked ? <EventAvailableIcon sx={{ fontSize: 10 }} /> :
                                                                value.classBooked ? <SportsTennisIcon sx={{ fontSize: 10 }} /> :
                                                                    value.price &&
                                                                    // <MKTypography variant="body2" fontWeight="regular" color="inherit">{value.price}</MKTypography>
                                                                    <div>{value.price}</div>
                                    }
                                </div>
                            </Grid>
                        )
                    })
                }
            </Grid>
            {/* <Confirm isOpen={calendarBody.open} setIsOpen={() => {
                setCalendarBody({
                    open: false,
                    info: null,
                    actionBody: null
                })
            }}>
                <Grid style={{
                    width: 300
                }} p={2}>{calendarBody.info}</Grid>
            </Confirm> */}
        </Grid>
    )
}

export const toUTC = (d, moment = false, format = 'YYYY-MM-DD') => {
    let offSetCount = d.getTimezoneOffset()
    if (offSetCount < 0) {
        if (moment) { return moment(new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000)).format(format) }
        else { return new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000) }
    } else {
        if (moment) { return moment(new Date(d.getTime() + d.getTimezoneOffset() * 60 * 1000)).format(format) }
        else { return new Date(d.getTime() + d.getTimezoneOffset() * 60 * 1000) }
    }
}

export const toGMT7 = (d, format = 'YYYY-MM-DD') => {
    // let offSetCount = d.getTimezoneOffset()
    // return moment(d.toISOString()).format(format)
    if (format == 'YYYY-MM-DD') {
        let currMonth = new Date(d).getMonth() + 1
        return `${new Date(d).getFullYear()}-${(currMonth < 10 ? `0${currMonth}` : currMonth)}-${new Date(d).getDate()}`
    } else {
        return moment(d.toISOString()).format(format)
    }
}

export const toGMTSelectedDate = (d, format = 'YYYY-MM-DD', timezone = 'Asia/Jakarta') => {
    // get curent offset
    // let timeZoneOffset = new Date().getTimezoneOffset()
    // console.log('here check e', timeZoneOffset, moment.tz.guess(), moment(d).utc())
    // console.log('here check e', timeZoneOffset, moment.tz.guess(), moment(d).utc().add(8, 'hour').format(format))
    // return moment(d).utc().add(8, 'hour').format(format)
    const momentDate = moment.tz(
        {
            year: d.getFullYear(),
            month: d.getMonth(),
            day: d.getDate(),
        },
        timezone
    );
    return momentDate.format(format)
}

export const momentFormat = (d, format = 'YYYY-MM-DD') => {
    return moment(d).format(format)
}

export const toLocalGMT = (d) => {
    return moment(d).toDate()
}

export const Hours = [
    {
        label: "00:00",
        active: false
    },
    {
        label: "01:00",
        active: false
    },
    {
        label: "02:00",
        active: false
    },
    {
        label: "03:00",
        active: false
    },
    {
        label: "04:00",
        active: false
    },
    {
        label: "05:00",
        active: false
    },
    {
        label: "06:00",
        active: false
    },
    {
        label: "07:00",
        active: false
    },
    {
        label: "08:00",
        active: false
    },
    {
        label: "09:00",
        active: false
    },
    {
        label: "10:00",
        active: false
    },
    {
        label: "11:00",
        active: false
    },
    {
        label: "12:00",
        active: false
    },
    {
        label: "13:00",
        active: false
    },
    {
        label: "14:00",
        active: false
    },
    {
        label: "15:00",
        active: false
    },
    {
        label: "16:00",
        active: false
    },
    {
        label: "17:00",
        active: false
    },
    {
        label: "18:00",
        active: false
    },
    {
        label: "19:00",
        active: false
    },
    {
        label: "20:00",
        active: false
    },
    {
        label: "21:00",
        active: false
    },
    {
        label: "22:00",
        active: false
    },
    {
        label: "23:00",
        active: false
    }
]

function MonthSelection({
    selectedDate,
    onChangeCalendar,
    closeCalendar,
    hourList
}) {
    console.log("isi sele", selectedDate)


    return (
        <Grid p={1}>
            <Calendar
                maxDetail="year"
                minDetail="year"
                className={"react-calendar"}
                onChange={(e) => {
                    onChangeCalendar(e)
                    closeCalendar(false)
                }}
                prev2Label={null}
                next2Label={null}
                defaultValue={selectedDate}
                showNavigation={true}
            // value={selectedDate}
            // tileClassName={(({ date }) => {
            //     const calendarDate = toGMTSelectedDate(date);
            //     const sd = toGMTSelectedDate(selectedDate);

            //     // console.log('Calendar Date:', calendarDate);
            //     // console.log('Selected Date:', selectedDate);
            //     // console.log('Server Date:', serverMomentDate);
            //     // console.log('Selected Date - check:', toGMTSelectedDate(serverDate), serverDate);
            //     // console.log('HourList:', hourList);
            //     if (calendarDate == sd) {
            //         return;
            //     }
            //     if (hourList.indexOf(calendarDate) >= 0) {
            //         return 'dotted'
            //     }
            // })}
            />
        </Grid>
    )
}

function serverDateConstructor(d, gmt = 7) {
    let year = new Date(d).getUTCFullYear();
    let month = new Date(d).getUTCMonth();
    let date = new Date(d).getUTCDate();
    let hours = new Date(d).getUTCHours();
    let minutes = new Date(d).getUTCMinutes();
    let second = 0;
    let ms = 0;
    return new Date(year, month, date, (hours + gmt), minutes, second, ms)
}

export default TCCalendar